import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {AuthService} from "../../../../services/auth.service";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MatIcon,
    NgClass
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  @Output() menuChange = new EventEmitter<boolean>();

  @Input() menuOpened: boolean = false;


  constructor(protected authService: AuthService) {
  }

  toggleMenu() {
    this.menuOpened = !this.menuOpened;
    this.menuChange.emit(this.menuOpened);
  }
}
